import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { Map, List, Iterable } from 'immutable';

import StructureThumbnailContainer from '@Containers/StructureThumbnail';
import Button from '@Components/Button';

export default class StructureData extends React.PureComponent {
  // eslint-disable-next-line react/sort-comp
  openBatchDetails = () => {
    const { breadcrumb, openBatchExecutionDetails } = this.props;
    openBatchExecutionDetails(breadcrumb.toJS());
  };

  getQuickSearchStructure() {
    const { breadcrumb } = this.props;
    return breadcrumb.getIn(['quickSearchItem', 'structure']);
  }

  getQueryBuilderStructures() {
    const { breadcrumb } = this.props;
    const structures = breadcrumb.get('structures');
    return Iterable.isIterable(structures) ? structures : List();
  }

  render() {
    const { breadcrumb, showStructurePopup } = this.props;
    const quickSearchStructure = this.getQuickSearchStructure();
    const queryBuilderStructures = this.getQueryBuilderStructures();

    return (
      <>
        <div className="crumb-comment">
          {breadcrumb.get('batchSearch') && (
            <Button
              buttonConfig={{
                type: 'link',
                label: 'Execution details',
                size: 'sm',
                className: 'pull-right breadcrumb-open-batch__button',
                e2eName: 'breadcrumb-open-batch',
              }}
              iconConfig={{ name: 'navigate-right', size: 'sm' }}
              onClick={this.openBatchDetails}
            />
          )}
          <InnerHTML tag="span" html={breadcrumb.get('batchComment') || breadcrumb.get('comment')} />
        </div>

        {quickSearchStructure && (
          <Button
            buttonConfig={{
              size: 'sm',
              className: 'els-btn-structure',
              e2eName: 'breadcrumb-structure',
              ariaLabel: 'Show quick search structure',
            }}
            onClick={() => {
              showStructurePopup(quickSearchStructure);
            }}>
            <StructureThumbnailContainer enableThumbnail={false} />
          </Button>
        )}

        {queryBuilderStructures.map((structureData, index) => (
          <Button
            buttonConfig={{
              size: 'sm',
              className: 'els-btn-structure',
              e2eName: 'breadcrumb-structure',
              ariaLabel: 'Show query builder structure',
            }}
            onClick={() => {
              showStructurePopup(structureData.get('structure'));
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={index}>
            <StructureThumbnailContainer enableThumbnail={false} />
          </Button>
        ))}
      </>
    );
  }
}

StructureData.propTypes = {
  breadcrumb: PropTypes.instanceOf(Map).isRequired,
  openBatchExecutionDetails: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
};
